import type {InvoiceTransaction, InvoiceTransactionType} from '../types';

import {MinusCircleOutlined, PlusCircleOutlined} from '@ant-design/icons';
import {Chip, Loading} from '@ds/components';
import {PageLayout} from '@ds/layout';
import {useEffect, useMemo, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from 'store';
import {getInvoiceTransaction} from 'store/slices/invoice/thunk';
import {numberFormat} from 'utils/Helper';

import InvoiceDataRow from '../components/common/InvoiceDataRow/InvoiceDataRow';

const InvoiceDetails: React.FC = () => {
  const dispatch = useAppDispatch();
  const {id} = useParams();
  const vendorId = JSON.parse(localStorage.getItem('selectedVendor') ?? 'null')?.id ?? '0';
  const {transaction, loading} = useAppSelector((state) => state.invoice);
  const [selectedTypes, setSelectedTypes] = useState<InvoiceTransactionType[]>([]);

  useEffect(() => {
    void dispatch(getInvoiceTransaction({vendor_id: vendorId, invoiceId: id}));
  }, [dispatch, id, vendorId]);

  const filteredTransactions = useMemo(() => {
    const transactions = Array.isArray(transaction) ? (transaction as InvoiceTransaction[]) : [];

    if (selectedTypes.length === 0) {
      return transactions;
    }

    return transactions.filter((item) => selectedTypes.includes(item.type));
  }, [selectedTypes, transaction]);

  const toggleType = (type: InvoiceTransactionType) => {
    setSelectedTypes((currentTypes) =>
      currentTypes.includes(type)
        ? currentTypes.filter((currentType) => currentType !== type)
        : [...currentTypes, type]
    );
  };

  return (
    <PageLayout
      header={
        <div className="flex gap-2.5 border-b border-gray-02 px-4 py-2">
          <Chip
            label="پرداختی‌ها"
            selected={selectedTypes.includes('addition')}
            onClick={() => toggleType('addition')}
          />
          <Chip
            label="کسری‌ها"
            selected={selectedTypes.includes('deduction')}
            onClick={() => toggleType('deduction')}
          />
        </div>
      }
    >
      {loading ? (
        <div className="flex flex-1 items-center justify-center">
          <Loading size="medium" mId="1" />
        </div>
      ) : (
        <div className="flex flex-col">
          {filteredTransactions.map((item) => {
            const isAddition = item.type === 'addition';

            return (
              <div
                key={`${item.type}-${item.id}`}
                className="border-b border-gray-02 last:border-0"
              >
                <InvoiceDataRow
                  tone={isAddition ? 'success' : 'error'}
                  title={
                    <span className="flex items-start gap-2">
                      {isAddition ? (
                        <PlusCircleOutlined className="mt-0.5 text-body-lg text-success" />
                      ) : (
                        <MinusCircleOutlined className="mt-0.5 text-body-lg text-destructive!" />
                      )}
                      <span>{item.reason}</span>
                    </span>
                  }
                  value={`${numberFormat(item.price ?? 0)} تومان`}
                />
              </div>
            );
          })}
        </div>
      )}
    </PageLayout>
  );
};

export default InvoiceDetails;
